import React, { useEffect, useState } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useLocation } from "react-router-dom";
import axios from "../../../axios-backend";
import BackButton from "../../main/BackButton";
import SwiperSlider from "../../main/SwiperSlider";
import { LazyImageWithLoader } from "../LazyImageWithLoader";

const ProductDimensions = (props) => {
  const location = useLocation();
  const { type } = location.state || {};

  const [images, setImages] = useState([]);
  useEffect(() => {
    axios
      .get(`/get-imgs-by-pid`, {
        params: {
          id: type,
          type: 3,
        },
      })
      .then((data) => {
        setImages(data.data.imgs);
      });
  }, [type]);

  return (
    <>
      <BackButton />
      <div className="singleContainer">
        <SwiperSlider>
          {images.map((i, index) => {
            const src = i.url.startsWith("s3")
              ? `https://wonwonleywon-images.s3.amazonaws.com/product_images/${i.url}`
              : `${process.env.REACT_APP_Url}${i.url}`;
            return (
              <LazyImageWithLoader
                src={src}
                alt={`Product ${index}`}
                style={{
                  minHeight: "300px",
                  maxHeight: "500px",
                  minWidth: "300px",
                  maxWidth: "500px",
                  padding: "10px 0",
                }}
              />
            );
          })}
        </SwiperSlider>
      </div>
    </>
  );
};

export default ProductDimensions;
